import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "dial-select" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"15px","width":"20px","background-color":"#d1d1d7","border-radius":"4px","margin-right":"0.75rem"}
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "menu shadow-dark rounded"
}
const _hoisted_5 = { class: "search px-15 mb-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "text-primary"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "divider" })
], -1)
const _hoisted_7 = ["onClick"]

import { onMounted, ref } from 'vue'
import { countries, Country } from '@/utils/countries'
import { get_geo, user_geo } from '@/utils/geo'
import DialcodeFlag from '@/components/ui/disalcode-flag.vue'

// props

export default /*#__PURE__*/_defineComponent({
  __name: 'dailcode-select',
  props: {
    value: {}
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {


const props = __props
// emits
const emit = __emit

const selected = ref({
    name: 'Italy',
    dial_code: '+39',
    code: 'IT'
  })

const active = ref(false)
const mounted = ref(false)
const countries_list = ref(countries)

const on_select = (country: any) => {
  selected.value = country
  emit('change', selected.value)
}
const toggle = () => {
  active.value = !active.value
}
const hide = () => {
  if (active.value) active.value = false
}
const set = (iso: string) => {
  selected.value = countries[iso]
  emit('change', selected.value)
}


const search_arr = Object.values(countries)
const on_search = (evt: Event) => {
  // @ts-ignore
  const { value } = evt.target
  const key = value.trim().toLowerCase();
  if (!key || key === '') {
    countries_list.value = countries
    return
  }

  countries_list.value = {}
  for (let i = 0; i < search_arr.length; i++) {
    const obj = search_arr[i]
    if (obj.name.toLowerCase().includes(key)) {
      countries_list.value[obj.code] = obj
    }
  }
}

onMounted(() => {
  if (props.value) {
    selected.value = countries[props.value]
    emit('change', selected.value)
  } else {

    if (user_geo) {
      selected.value = countries[user_geo]
      emit('change', selected.value)
    } else {
      const iso2 = get_geo() ?? 'ES'
      selected.value = countries[iso2]
      emit('change', selected.value)
    }
  }

  setTimeout(() => {
    mounted.value = true
  }, 100)
})

return (_ctx: any,_cache: any) => {
  const _directive_blur = _resolveDirective("blur")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
    }, [
      (!mounted.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true),
      (mounted.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: `/img/flags/${selected.value.code.toLowerCase()}.svg`,
            alt: selected.value.code
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(selected.value.dial_code), 1)
    ]),
    (mounted.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("input", {
              type: "text",
              name: "search",
              placeholder: "",
              class: "input",
              onInput: on_search
            }, null, 32)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries_list.value, (c, i) => {
            return (_openBlock(), _createElementBlock("a", {
              key: i,
              onClick: ($event: any) => (on_select(c))
            }, [
              _createVNode(DialcodeFlag, { country: i }, null, 8, ["country"]),
              _createElementVNode("span", null, _toDisplayString(c.dial_code), 1),
              _createElementVNode("span", null, _toDisplayString(c.name), 1)
            ], 8, _hoisted_7))
          }), 128))
        ], 512)), [
          [_vShow, active.value]
        ])
      : _createCommentVNode("", true)
  ])), [
    [_directive_blur, hide]
  ])
}
}

})